import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const base = `${API_BASE_URL}/Purchase`;

/** HSN Category lookup (e.g. Chapter/Category master used alongside Goods/Service) */
export const getHSNCategory = () =>
    axios.get(`${base}/GetHSNCategory`);

/** All existing HSN/SAC codes — used to populate the "Updation" dropdown */
export const getHSNCodes = () =>
    axios.get(`${base}/GetHSNCodes`);

/** Full HSN row by its id — used to prefill the form when Updation + a code is picked */
export const getHSNDetailsById = (id) =>
    axios.get(`${base}/GetHSNDetails`, { params: { Id: id } });

/** Create a new HSN/SAC code, or resubmit an existing one for re-verification */
export const saveHSNDetails = (payload) =>
    axios.post(`${base}/SaveHSNDetails`, payload);
